import React from 'react';
import { useAuth } from './components/auth';
import CrmApp from './crm/App';
import Login from './components/auth/Login';
import OAuthCallbackPage from './crm/components/communications/OAuthCallbackPage';

// Owner and Resident apps will be imported here when implemented
// import OwnerApp from './owner/App';
import ResidentApp from './resident/App';

const AppRouter: React.FC = () => {
  const { user, loading: authLoading } = useAuth();
  const isOAuthCallback = window.location.pathname === '/callback';

  // Handle OAuth2 callback from Google before auth/role routing.
  if (isOAuthCallback) {
    return <OAuthCallbackPage />;
  }

  const handleLoginSuccess = () => {
    // login() already sets user from the response; re-fetching /me here can race the Set-Cookie
  };

  // Show loading screen while checking authentication
  if (authLoading) {
    return (
      <div className="app">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!user) {
    // Reset logging out flag when showing login (in case it was set)
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  // Route to appropriate portal based on user role
  const role = user.allowedAccess;

  if (role === 'crm') {
    return <CrmApp />;
  } else if (role === 'owner') {
    // TODO: Implement Owner app
    return (
      <div className="app">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <div>
            <h1>Owner Portal</h1>
            <p>Owner application is coming soon.</p>
          </div>
        </div>
      </div>
    );
  } else if (role === 'resident') {
    return <ResidentApp />;
  } else {
    // User has 'none' role or invalid role - deny access
    return (
      <div className="app">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <div>
            <h1>Access Denied</h1>
            <p>You do not have access to any portal. Please contact your administrator.</p>
          </div>
        </div>
      </div>
    );
  }
};

export default AppRouter;

